module.exports = __webpack_public_path__ + "img/avatar-1.02aea0c2.jpg";